//export const NFT_SUB_GRAPH_URL = 'https://api.thegraph.com/subgraphs/name/yetiswap/nft-market'
export const NFT_SUB_GRAPH_URL = 'https://api.thegraph.com/subgraphs/name/yetiswap/yetiswap-nft-market-boba'
export const NFT_ERC721_GRAPH_URL = 'https://api.thegraph.com/subgraphs/name/yetiswap/boba-erc-721'
export const NFT_ERC721_GRAPH_URL_TEST_NET = 'https://nftgraphql.yetiswap.app/subgraphs/name/yetiswap/avalanche-erc721'


/*
* Bizim sunucu
* https://nftgraphql.yetiswap.app/subgraphs/name/yetiswap/nft-market-mainnet2
*
*The Graph
* https://api.thegraph.com/subgraphs/name/yetiswap/nft-market
* */